import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FeedMessagesState {
  count: number;
  viewedIDs: number[];
}

const initialState: FeedMessagesState = {
  count: 0,
  viewedIDs: [],
};

const feedMessagesSlice = createSlice({
  name: 'feedMessages',
  initialState,
  reducers: {
    decrementFeedMessageCount: (state, { payload }: PayloadAction<number>) => {
      if (!state.viewedIDs.includes(payload)) {
        state.count = state.count - 1;
      }
    },
    setUnreadCount: (state, { payload }: PayloadAction<number>) => {
      if (state.viewedIDs.length === 0) {
        state.count = payload;
      }
    },
    setViewedIDs: (state, { payload }: PayloadAction<number>) => {
      if (!state.viewedIDs.includes(payload)) {
        state.viewedIDs.push(payload);
      }
    },
  },
});

const { reducer, actions } = feedMessagesSlice;

export const { decrementFeedMessageCount, setUnreadCount, setViewedIDs } =
  actions;

export const feedMessagesReducer = reducer;
